import { useState } from "react";
import type { CreateFormAdminTypes } from "../../types/admin/admin.form";
import buttonLoadingAnimation from "../../animations/buttonLoading.json";
import Lottie from "lottie-react";
import { useAppDispatch } from "../../redux/hooks";
import { createAdmin } from "../../redux/slices/adminSlice";
import { toast } from "react-toastify";
import { getErrorMessage } from "../../utils/errorHandler";

export interface Payload {
  handleShowFormCreate: (status: boolean) => void;
}

export const CreateAdmin = ({ handleShowFormCreate }: Payload) => {
  const dispatch = useAppDispatch();
  const [formData, setFormData] = useState<CreateFormAdminTypes>({
    name: "",
    email: "",
    password: "",
    isActive: true,
    role: "admin",
  });

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>,
  ) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: name === "isActive" ? value === "true" : value,
    }));
  };

  const [loading, setLoading] = useState<boolean>(false);
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!formData.name.trim()) {
      toast.error("Tên admin không được để trống");
      return;
    }
    if (!formData.email.trim()) {
      toast.error("Email không được để trống");
      return;
    }
    if (!formData.password || formData.password.length < 6) {
      toast.error("Mật khẩu phải có ít nhất 6 ký tự");
      return;
    }
    setLoading(true);
    try {
      await dispatch(createAdmin(formData)).unwrap();
      toast.success("Tạo admin thành công");
      handleShowFormCreate(false);
    } catch (error) {
      toast.error(getErrorMessage(error));
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center p-3 z-50">
      <div className="p-5 bg-white rounded-lg w-full max-w-md space-y-2">
        <div className="flex items-center justify-center">
          <p className="text-lg font-semibold text-gray-700">Thêm admin</p>
        </div>
        <form onSubmit={handleSubmit} className="space-y-2">
          <div className="space-y-2">
            <label className="block text-sm font-semibold text-gray-700">
              Tên admin
            </label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              className="p-2 focus:outline-none focus:border-blue-500 transition-colors duration-300 border border-gray-200 rounded-xl w-full placeholder:text-sm placeholder:tracking-tighter placeholder:text-gray-400"
              placeholder="Ex. Thành Phát"
            />
          </div>
          <div className="space-y-2">
            <label className="block text-sm font-semibold text-gray-700">
              Email
            </label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              className="p-2 focus:outline-none focus:border-blue-500 transition-colors duration-300 border border-gray-200 rounded-xl w-full placeholder:text-sm placeholder:tracking-tighter placeholder:text-gray-400"
              placeholder="Ex. thanhphat@gmail.com"
            />
          </div>
          <div className="space-y-2">
            <label className="block text-sm font-semibold text-gray-700">
              Mật khẩu
            </label>
            <input
              type="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              className="p-2 focus:outline-none focus:border-blue-500 transition-colors duration-300 border border-gray-200 rounded-xl w-full placeholder:text-sm placeholder:tracking-tighter placeholder:text-gray-400"
              placeholder="Ex. Thành Phát"
            />
          </div>
          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3">
            <div className="space-y-2">
              <label className="block text-sm font-semibold text-gray-700">
                Vai trò
              </label>
              <select
                name="role"
                value={formData.role}
                onChange={handleChange}
                className=" border border-gray-200 rounded-xl p-2 cursor-pointer text-sm text-gray-700 focus:outline-none focus:border-blue-500 transition-colors duration-300"
              >
                <option value="admin">Admin</option>
              </select>
            </div>
            <div className="space-y-2">
              <label className="block text-sm font-semibold text-gray-700">
                Trạng thái
              </label>
              <select
                name="isActive"
                value={String(formData.isActive)}
                onChange={handleChange}
                className=" border border-gray-200 rounded-xl p-2 cursor-pointer text-sm text-gray-700 focus:outline-none focus:border-blue-500 transition-colors duration-300"
              >
                <option value="true">Hoạt động</option>
                <option value="false">Ngừng hoạt động</option>
              </select>
            </div>
          </div>
          <div className="flex items-center justify-between">
            <div className="">
              <button
                type="button"
                onClick={() => handleShowFormCreate(false)}
                className="p-2 text-white text-sm bg-blue-500 hover:bg-blue-600 rounded-lg cursor-pointer"
              >
                Quay lại
              </button>
            </div>
            <div className="flex items-center gap-2">
              <button
                type="button"
                className="p-2 text-white text-sm bg-red-500 hover:bg-red-600 rounded-lg cursor-pointer"
              >
                Hủy
              </button>
              {loading ? (
                <Lottie
                  animationData={buttonLoadingAnimation}
                  loop={true}
                  className="h-10 w-20"
                />
              ) : (
                <button
                  type="submit"
                  className="p-2 text-white text-sm bg-green-500 hover:bg-green-600 rounded-lg cursor-pointer"
                >
                  Thêm admin
                </button>
              )}
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};
